export default __webpack_public_path__ + "pages/slides-1ae9e1ed0b7748007595fb8c8cdb4afb.html";